export enum PersonalDataCvSections {
  LANGUAGES = 'LANGUAGES',
  STUDIES = 'STUDIES'
}
